import React from 'react';

interface CharacterSpanProps {
    type: 'GSM' | 'NOTGSM' | 'UNICODE';
    character: string;
}

const CharacterSpan: React.FC<CharacterSpanProps> = ({ type, character }) => {
    return (
        <React.Fragment>
            <span
                className={`m-0.5 inline-block w-7 h-9 rounded-sm text-xl align-middle text-center
                             leading-9 font-medium animate__animated ${
                                 type === 'GSM'
                                     ? 'bg-gray-300 animate__fadeIn'
                                     : type === 'NOTGSM'
                                     ? 'bg-yellow-400 text-white animate__heartBeat'
                                     : 'bg-red-400 text-white animate__tada'
                             }  animate__faster`}
            >
                {character}
            </span>
        </React.Fragment>
    );
};

export default CharacterSpan;
